import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Alert from 'react-s-alert';
import { change, Field, reduxForm, reset } from 'redux-form';
import classNames from 'classnames';

import ProgramModal from './program_Modal';
import { renderCheckBox, renderTextField, renderToggleButton } from '../../../../../components/reduxFields';
import { alertConfirmation, resetFiltersAndSorting } from '../../../../../actions/utilAction';
import SortingCustom from '../../../../../components/SortingCustom';
import { getProgramList, deleteProgram, updateProgramActiveStatus } from './actions/programActions';
import PaginatorCustom from '../../../../../components/paginationCustom';
import Target from '../target/index';
import { CommonButton } from '../../../../../components/buttons';
import { UpdateDCArchiveStatus } from '../../actions/CurriculumLibrariesActions';

const stylescss = {
    checkbox: {
      marginBottom: 16,
    },
  };

class Program extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isTarget: false,
            programId: null,
            domainId: props.domainIdForProgram,
            ProgramIdForTarget: null,
            programName: '',
            activeProgramToggleValues: [],
            selectedLibraryIds: [],     
            ShowArchivedOnly : false,   
        }
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.handleSearchPrograms = this.handleSearchPrograms.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.loadProgramsData = this.loadProgramsData.bind(this);
        this.CheckProgram = this.CheckProgram.bind(this);
        this.ResetAllCheckBoxes = this.ResetAllCheckBoxes.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_program && nextProps.saved_program !== this.props.saved_program) {
            this.loadData();
        }
        if (nextProps.deleted_program && nextProps.deleted_program !== this.props.deleted_program) {
            this.loadData();
        }

        let programListArray = (nextProps.programData && nextProps.programData.data) || [];
        let activeProgramToggleValues = new Array(programListArray.length).fill({});
        let index = 0;
        programListArray.map((obj) => {
            if (activeProgramToggleValues.indexOf(obj) === -1) {
                activeProgramToggleValues.splice(index, 1, obj);
            index = index + 1;
            }
            return activeProgramToggleValues;
        });

        this.setState({
            activeProgramToggleValues,
         });

         if (nextProps.archiveBatchDCStatus && nextProps.archiveBatchDCStatus !== this.props.archiveBatchDCStatus) {
            this.setState({ selectedLibraryIds : [] },()=>{
                this.ResetAllCheckBoxes();
              this.loadData();
            });      
          }  
    }

    componentWillUnmount() {
        Alert.closeAll();
    }

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0', },
            pageNumber: page_number || 1,
        };
        this.props.getProgramList(searchObj, this.props.domainIdForProgram);
    }

    handleOpen = () => {
        Alert.closeAll();
        this.setState({ open: true, programId: null });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    onClickHandler = (e, obj) => {
        this.setState({
            ProgramIdForTarget: obj.id,
            isTarget: true,
            programName: obj.programName
        })
        this.loadData()
    }

    
    onBackClick = () => {
        this.setState({
            ProgramIdForTarget: null,
            isTarget: false,
            programName: ''
        })
        this.loadData();
    }

    ResetAllCheckBoxes()
      {
        this.props.programData != null && this.props.programData && this.props.programData.data.forEach((obj, Index) => {
            let idCheck = `Claims[${Index}].Chk`;                
            this.props.dispatch(change('ManageProgramForm', idCheck, false));                
        });
      }

    handleAlertArchiveBatchProgramsClick = (event) => {
        this.props.UpdateDCArchiveStatus(this.state.selectedLibraryIds.toString(), true, 'MasterProgram');
        Alert.closeAll();
      }
    
      handleArchiveBatchProgramsClick = (event) => {
        Alert.warning('Are you sure you want to archive selected program(s)?', {
          position: 'bottom-right',
          effect: 'slide',
          timeout: 10000,
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleAlertArchiveBatchProgramsClick,
            //id: obj.id,
          },
        });
      }

      handleAlertUnArchiveBatchProgramsClick = (event) => {
        this.props.UpdateDCArchiveStatus(this.state.selectedLibraryIds.toString(), false, 'MasterProgram');
        Alert.closeAll();
      }
    
      handleUnArchiveBatchProgramsClick = (event) => {
        Alert.warning('Are you sure you want to unarchive selected program(s)?', {
          position: 'bottom-right',
          effect: 'slide',
          timeout: 10000,
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleAlertUnArchiveBatchProgramsClick,
            //id: obj.id,
          },
        });
      }

    CheckProgram(e, index, data) {    
        let selectedLibraryIds = this.state.selectedLibraryIds;        
        let isChecked = e.target.checked;
        if (isChecked) {     
            selectedLibraryIds.push(data.id);              
        } else {     
            index = selectedLibraryIds.findIndex((value) => value === data.id);
            if (index >= 0) {
                selectedLibraryIds.splice(index, 1);         
            }      
        }
        this.setState({ selectedLibraryIds });
      }

    onActiveProgramToggle(e, index, Obj) {
        alertConfirmation('Are you sure you want to change program\'s active status?', {
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleActiveProgramAlertClick,
            // value: e.target.value,
            id: index,
            userID: Obj.id,
          },
        });    
    };

    handleActiveProgramAlertClick = (event, index, userID) => {
        let activeProgramToggleValues = this.state.activeProgramToggleValues;
        activeProgramToggleValues[index].isActive = !activeProgramToggleValues[index].isActive;
        this.setState({ activeProgramToggleValues });
        this.props.updateProgramActiveStatus(userID, this.state.activeProgramToggleValues[index].isActive, this.props.domainIdForProgram);
        Alert.closeAll();
    };

    handleSearchPrograms() {
        return false;
    }

    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    }

    handleReset = () => {
        Alert.closeAll();
        this.props.dispatch(reset('ManageProgramForm'));
        resetFiltersAndSorting(this.filter, 'id', true);
        this.filter.sort_Column = '';
        this.filter.sort_order = '';
        this.setState({ ShowArchivedOnly : false  }, ()=>{this.loadData();});
    };

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }

    loadProgramsData()
    {
        this.filter.sort_Column = '';
        this.filter.sort_order = '';
        this.loadData();
    }

    handleEditClick = (event, obj) => {
        Alert.closeAll();
        this.setState({ open: true, programId: obj.id });
    }

    handleAlertClick = (event, programId) => {
        this.props.deleteProgram(programId);
        Alert.closeAll();
    }

    handleDeleteClick = (event, obj) => {
        alertConfirmation('Are you sure you want to delete program details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClick,
                id: obj.id,
            },
        });
    }

    handleAdvanceFilterCheck = (input, name) => {
        this.setState({ [name]: input.target.checked },
          () => {
            this.loadData();
          });
      }

    renderData(programList) {
        programList = programList || [];
        if (!programList.length) {
            return (
                <tr>
                    <td colSpan="4">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return programList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td width="5%">
                        <div className="table_custom-check">
                        <Field
                            name={`Claims[${index}].Chk`}
                            component={renderCheckBox}
                            onChange={(e) => this.CheckProgram(e, index, Obj)}
                            style={stylescss.checkbox}
                        />
                        </div>
                    </td>
                    <td><a href="#" onClick={(e) => this.onClickHandler(e, Obj)}><i className="fa fa-folder" style={{ color: '#F0E68C', cursor: 'pointer' }}></i>&nbsp;{Obj.programName}</a></td>
                    {/* <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td> */}
                    <td>
                        <Field className="no_margin"
                            name="program_active_status"
                            toggled={this.state.activeProgramToggleValues[index] && this.state.activeProgramToggleValues[index].isActive ? this.state.activeProgramToggleValues[index].isActive : false}
                            component={renderToggleButton}
                            onChange={(e) => this.onActiveProgramToggle(e, index, Obj)}
                        />
                    </td>
                    <td>
                        <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                        <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                    </td>
                </tr>
            )
        })
    }

    programRender = () => {
        const { handleSubmit, programData } = this.props;
        let programList = (programData && programData.data) || [];
        let domainMeta = (programData && programData.meta) || null
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        return (
            <div>
                <h2 className="page_title">Manage Curriculum Libraries {' > '} {this.props.libraryName} {' > '} {this.props.domainName} {' > '} Programs</h2>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="modalwindow">
                            <div className="row">
                                <div className="col-sm-2">
                                    <RaisedButton label="Back" primary={true} onTouchTap={() => this.props.onBackClick()} />
                                </div>
                                <div className="col-sm-3">
                                    <RaisedButton label="Add Program" primary={true} onTouchTap={this.handleOpen} />
                                </div>
                                <div className="col-sm-3">
                                    <CommonButton className={this.state.selectedLibraryIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedLibraryIds.length > 0 && !this.state.ShowArchivedOnly ? false : true} label="Mark as Archived" onTouchTap={(e) => this.handleArchiveBatchProgramsClick(e)} />
                                </div>
                                <div className="col-sm-3">
                                    <CommonButton className={this.state.selectedLibraryIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedLibraryIds.length > 0 && this.state.ShowArchivedOnly ? false : true} label="Mark as Unarchived" onTouchTap={(e) => this.handleUnArchiveBatchProgramsClick(e)} />
                                </div>    
                            </div>
                            <div className="row mt-20">
                                <div className="col-sm-4 field-mr">
                                    <Field
                                    name="ShowArchivedOnly"
                                    label="Show Archived Only"
                                    component={renderCheckBox}
                                    onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowArchivedOnly')}
                                    />
                                </div>    
                                <div className="col-sm-8">
                                    <div className="row end-flex">
                                        <div className="col-sm-6 mtm-27">
                                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchPrograms)}>
                                                <Field
                                                    name="program"
                                                    floatingLabelText="Search"
                                                    maxLength='250'
                                                    onChange={this.handleSearchChange}
                                                    component={renderTextField}
                                                />
                                            </form>
                                        </div>
                                        <div className="reset-btn col-sm-3 btn_rt">
                                            <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.open && <ProgramModal programId={this.state.programId} closeDialog={this.handleClose} domainId={this.state.domainId} loadProgramsData={this.loadProgramsData} />}
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive mt-15">
                                    <table className={tableClass}>
                                        <thead>
                                            <tr>
                                                <th width="5%"></th>
                                                <th width="50%"><SortingCustom noSort={!programList.length} setSortColumn={this.setSortColumn} columnName='programName' displayName='Name' /></th>
                                                <th width="25%">Active</th>
                                                <th width="20%">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderData(programList)}
                                        </tbody>
                                    </table>
                                    {domainMeta && domainMeta['totalPages'] ?
                                        <PaginatorCustom data={domainMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            this.state.isTarget === false 
            ?
            this.programRender()
            :
            <Target
            ProgramIdForTarget={this.state.ProgramIdForTarget}
            domainIdForTarget={this.state.domainId}  
            libraryName={this.props.libraryName}
            domainName={this.props.domainName}
            programName={this.state.programName}
            onBackClick={this.onBackClick}
            masterDomains={this.props.masterDomains}
            masterPrograms={this.props.masterPrograms}
            desiredDailyTrials={this.props.desiredDailyTrials}
            autoOpenOrder={this.props.autoOpenOrder}
            targetType={this.props.targetType}
            responsePercentage={this.props.responsePercentage}
            consecutiveDays={this.props.consecutiveDays}
            firstTrialMustBeIndependent={this.props.firstTrialMustBeIndependent}
            curriculumLibraryId={this.props.curriculumLibraryId}
            />
        )
    }
}

Program = reduxForm({
    form: 'ManageProgramForm',
})(Program);

function mapStateToProps(state) {
    return {
        loading: state.program.loading,
        programData: state.program.programList,
        saved_program: state.program.saved_programList,
        deleted_program: state.program.deleted_programList,
        archiveBatchDCStatus: state.curriculumLibraries.archiveBatchDCStatus,    
    }
}

export default connect(mapStateToProps, { getProgramList, deleteProgram, updateProgramActiveStatus, UpdateDCArchiveStatus })(Program);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/program/index.js